var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cloud-disk-sms-user-list')
}
var staticRenderFns = []

export { render, staticRenderFns }